import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL;

export function getFileUrl(url) {
  if (!url) return "";

  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  return new URL(
    url,
    BACKEND_URL,
  ).href;
}